// extracted by mini-css-extract-plugin
export default {"idText":"ApplicationIdCell_idText__2rvZl","copyButton":"ApplicationIdCell_copyButton__3XM2e","emptyState":"ApplicationIdCell_emptyState__1Pl50"};